import axiosFetch from './config';


export const getExchangeRate = async(originCurrencyId,destinationCurrencyId)=>{
    const token = await localStorage.getItem('token')
    return axiosFetch({
      method:'GET',
      url: `/exchangeRates?originCurrencyId=${originCurrencyId}&destinationCurrencyId=${destinationCurrencyId}`,
      headers: {
        Authorization: 'Bearer ' + token,
      }
    })
} 